import { render, staticRenderFns } from "./addProductCode.vue?vue&type=template&id=194f423c&scoped=true&"
import script from "./addProductCode.vue?vue&type=script&lang=js&"
export * from "./addProductCode.vue?vue&type=script&lang=js&"
import style0 from "./addProductCode.vue?vue&type=style&index=0&id=194f423c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194f423c",
  null
  
)

export default component.exports